<form
  class="filter-form flex"
  [formGroup]="filterForm"
>
  <payee-form-field width="short">
    <span payee-label>Ettől a dátumtól kezdve</span>
    <payee-datepicker formControlName="from_date"></payee-datepicker>
  </payee-form-field>
  <payee-form-field width="short">
    <span payee-label>Eddig a dátumig</span>
    <payee-datepicker formControlName="to_date"></payee-datepicker>
  </payee-form-field>
  <button
    payee-button
    width="short"
    (click)="getCharts()"
  >
    Frissítés
  </button>
</form>

<table
  mat-table
  matSort
  [dataSource]="dataSource"
>
  @for (column of displayedColumns; track column) {
    <ng-container [matColumnDef]="column">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
      >
        {{ column }}
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        @if (column === "claims") {
          {{ element[column] | json }}
        } @else {
          {{ element[column] }}
        }
      </td>
    </ng-container>
  }

  <tr
    *matHeaderRowDef="displayedColumns"
    mat-header-row
    class="main-header"
  ></tr>
  <tr
    *matRowDef="let element; columns: displayedColumns"
    mat-row
    class="element-row mat-elevation-z2"
  ></tr>
</table>
